// extracted by mini-css-extract-plugin
module.exports = {"section__wrapper":"d_b","section__content":"d_m","section__copyLiner":"d_n header","timezone__wrapper":"d_p","timezone__header":"d_q header","timezone__body":"d_r"};